module.exports = __webpack_public_path__ + "static/media/travolta.137ca9e2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/NotFound/travolta.gif
// module id = 627
// module chunks = 0